import React, { useEffect } from "react";
import Routes from "./routes/index";
import { BrowserRouter as Router, useLocation, useHistory } from "react-router-dom";
import routers from "routes/routes";
import "./assets/css/style.css";
import { HelmetProvider } from "react-helmet-async";

function App() {
  const location = useLocation();
  const path = location.pathname;

  const history = useHistory();

  useEffect(() => {
    const found = routers.some((route) =>
      route.childrens?.some((child) => {
        if (`${route.path}`.toLowerCase() === `/${path.split("/")[1]}`.toLowerCase()) {
          if (path.split("/").length > 2) {
            if (`${route.path}${child.path}`.toLowerCase() === path.toLowerCase()) {
              return true;
            } else {
              return false;
            }
          } else {
            return true;
          }
        } else {
          if (path === "/") {
            return true;
          } else {
            return false;
          }
        }
      })
    );
    function refreshPage() {
      window.location.reload(false);
    }

    if (!found) {
      if (path.split("/")[1] === "neet-college-predictor" || path.split("/")[1] === "neet-ug") {
        window.open("https://zynerd.com/", "_self");
      } else {
        if (path.split("/")[1] === "portal" && path.split("/")[2] === "videos") {
          window.open("/videos", "_self");
        } else {
          if (path === "/dashboard" || path === "/dashboard/") {
            window.open("/portal/dashboard", "_self");
          } else if (
            (path.split("/")[1] === "institutes" || path.split("/")[1] === "blogs") &&
            path.split("/")[2] !== null
          ) {
            return;
          } else {
            history.push("/error/page-not-found");
            refreshPage();
          }
        }
      }
    } else {
      if (path === "/portal" || path === "/portal/") {
        window.open("/portal/dashboard", "_self");
      }
    }
  }, [path, history]);

  return <Routes />;
}

function Main() {
  return (
    <HelmetProvider>
      <Router>
        <App />
      </Router>
    </HelmetProvider>
  );
}

export default Main;
